export default {"src":"/_next/static/media/arrow-right.29b46bd1.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};